import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/billableWork`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/billableWork`;

export const URL = (): RouteDefinition => `${baseRoute}/billableWork`;
